export const UPLOAD_TYPE_AVATAR = 'AVATAR';
export const UPLOAD_TYPE_FEATURED_IMAGE = 'CMS_FEATURED_IMAGE';
export const UPLOAD_TYPE_DOCUMENT = 'DOCUMENT';
export const UPLOAD_TYPE_CLAIM_DOCUMENT = 'CLAIM_DOCUMENT';
